export const API_URL = "https://checkout.franquezatech.com";
export const LOCAL_URL = "https://028e-179-54-107-170.ngrok-free.app";
